import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import AmazonRedshiftReaderForm from '../forms/amazon-redshift-reader-form';
import { amazonRedshiftReaderValidationSchema } from '../schema/amazonRedshiftReader.js';

export default function AmazonRedshiftReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Amazon Redshift Reader Node Details',
        altText: 'Amazon Redshift Reader Node',
        defaultLabel: 'Redshift Reader Node',
      }}
    >
      <CommonNode
        FormComponent={AmazonRedshiftReaderForm}
        schemaResolver={amazonRedshiftReaderValidationSchema}
      />
    </NodeProvider>
  );
}
